<template>
  <authorization permissionKey="surgery_ward_reception_queue" can="read">
    <attendances queueType="surgery_reception" medicalRecordPath="indicacao-cirurgica" />
  </authorization>
</template>

<script>
import attendances from "@/components/queues/attendances.vue";

  export default {
    name: "SurgicalWardReception",
    components: {
      attendances,
    },
  };
</script>

<style lang="scss" scoped></style>
